module.exports = __webpack_public_path__ + "img/alentour4.640920c6.jpg";